<cdx-aside-right [options]="rightOptions" *ngIf="envelope" class="d-flex justify-content-between">
  <h3>{{ envelope.title }}</h3>
  <div class="d-flex mt-2 mb-3">
    <cdx-pill [options]="pill"></cdx-pill>
  </div>
<div class="mb-3">
  <cdx-card-collapse [isCollapsed]="false" [isCardBox]="true" (onCollapse)="collapseClosed($event)">
    <div class="header align-items-center d-flex">
      <span class="font-weight-bold gray">{{ "generalInformation" | translate | titlecase }}</span>
      <div *ngIf="(envelope.createdByUserId === userId || isAdmin)&& canShowEditButton && envelope.status !== 2 && envelope.status !== 4 && envelope.status !== 5 && envelope.status !== 6"
        class="col text-right mr-n4 mt-1">
        <button class="cdx-btn__icon--xs gray border-less"
          (click)="showModalEnvelopeEditOrDeleteOrArchived(modalEnvelopeForm, 'Signer_Enviado_Detalhe_Editar')">
          <fa-icon class="gray" ngbTooltip="{{ 'envelope.sent.edit' | translate | titlecase }}" [icon]="['far','edit']">
          </fa-icon>
        </button>
      </div>
    </div>
    <div class="body">
      <small>
        <dl class="detail-columns mb-0">
          <dt class="col-sm-6 text-column gray">{{ "envelopeId" | translate }}:</dt>
          <dd class="col-sm-6">{{ envelope.id }}</dd>
          <dt class="col-sm-6 text-column gray">{{ "creator" | translate | titlecase }}:</dt>
          <dd class="col-sm-6">{{ (envelope.suiteUserName !== null ? envelope.suiteUserName : "integration") | translate
            | titlecase }}</dd>
          <dt class="col-sm-6 text-column gray">{{ "creation" | translate | titlecase }}:</dt>
          <dd class="col-sm-6">{{ envelope.creationDate | datetimeFormatLanguage:
            datetimeFormatLanguageEnum.datetime }}</dd>

          <div *ngIf="envelope.status !== sentEnvelopeStatus.reproved">
              <dt class="col-sm-6 text-column gray">{{
                (envelope.status !== sentEnvelopeStatus.deleted ? "lastmodified" :
                  "deleted") | translate | titlecase }}:</dt>

                  <dd class="col-sm-6">{{ envelope.lastModifiedDate | datetimeFormatLanguage:
                    datetimeFormatLanguageEnum.datetime }}</dd>
          </div>    

          <div *ngIf="envelope.status === sentEnvelopeStatus.reproved">
                <dt  class="col-sm-6 text-column gray">{{ "reproved" |
                  translate | titlecase }}:</dt>

                <dd class="col-sm-6">{{ reprovedDate | datetimeFormatLanguage:
                    datetimeFormatLanguageEnum.datetime }}</dd>
          </div> 

          <div *ngIf="envelope.status === sentEnvelopeStatus.deleted && envelope.userNameDelete !== null">
            <dt class="col-sm-6 text-column gray">{{ "deletedBy" | translate | titlecase }}:</dt>
            <dd class="col-sm-6">{{ envelope.userNameDelete }}</dd>
          </div>
          <div *ngIf="envelope.status === sentEnvelopeStatus.completed">
            <dt class="col-sm-6 text-column gray">{{ "conclution" | translate | titlecase }}:</dt>
            <dd class="col-sm-6">{{ envelope.conclutionDate | datetimeFormatLanguage:
              datetimeFormatLanguageEnum.datetime }}</dd>
          </div>
          <div *ngIf="envelope.status !== sentEnvelopeStatus.completed">
            <dt class="col-sm-6 text-column gray">{{ "expiration" | translate | titlecase }}:</dt>
            <dd class="col-sm-6">
              <i style="margin-top: 3px; margin-right: 4px;" class="fas fa-hourglass-half"></i>{{ envelope.expiration
              !== null && envelope.expiration !== '' ? (envelope.expiration | date:getDateFormat()) :
              ('envelope.listGrid.noExpiration' | translate |
              titlecase) }}
            </dd>
          </div>
          <dt class="col-sm-6 text-column gray">{{ "segment" | translate | titlecase }}:</dt>
          <dd class="col-sm-6 divSegment"><i style="margin-top: 3px; margin-right: 4px;" class="fas fa-folder"></i>{{
            envelope.segment !== null ? envelope.segment.name : 'none' | translate | titlecase }}</dd>
          <dt class="col-sm-6 text-column gray">{{ "reminder" | translate | titlecase }}:</dt>
          <dd class="col-sm-6"><i style="margin-top: 3px; margin-right: 4px;" class="far fa-paper-plane"></i>{{
            getDescriptionReminderFrequency() }}</dd>
        </dl>
      </small>
    </div>
  </cdx-card-collapse>
</div>

<div class="mb-3">
  <cdx-card-collapse [isCollapsed]="false" [isCardBox]="true" *ngIf="envelope.status === sentEnvelopeStatus.rejected">
    <div class="header align-items-center d-flex text-nowrap">
      <span class="font-weight-bold gray">{{ 'signatureRejected' | translate }}</span>
      <span class="labels-gray-num">&nbsp;&nbsp;{{ totalSignatoriesRejectedReason.length }}/{{ envelope.totalSignatures }}</span>
      <span class="labels-gray">&nbsp;&nbsp;{{ "rejected" | translate }}</span>
    </div>
    <div class="body">
      <dl class="mb-0">
        <dt *ngFor="let signatory of envelope.signatories">
          <div *ngIf="signatory?.envelopeRejectedHistory?.length > 0" class="position-relative">
            <fa-icon class="mr-1 danger" placement="right"
                    [icon]="['fas','times-circle']"></fa-icon>
            <span class="font-weight-bold">{{signatory.name}}</span>

            <div *ngIf="signatory.envelopeRejectedHistory[0].rejectReason.length < 240"
                class="ml-2 mb-2 mt-1">
              {{ getTranslatedReasons(signatory.envelopeRejectedHistory[0].rejectReason, signatory.envelopeRejectedHistory[0].rejectReasonOthers) }}
            </div>
            <div *ngIf="signatory.envelopeRejectedHistory[0].rejectReason.length >= 240"
                class="ml-2 mb-2 mt-1 texto-grande"
                placement="top"
                [ngbTooltip]="signatory.envelopeRejectedHistory[0].rejectReason">
              {{ getTranslatedReasons(signatory.envelopeRejectedHistory[0].rejectReason, signatory.envelopeRejectedHistory[0].rejectReasonOthers) }}
            </div>
          </div>
        </dt>
      </dl>
    </div>
  </cdx-card-collapse>  
</div>

<div class="mb-3">
  <cdx-card-collapse [isCollapsed]="false" [isCardBox]="true" *ngIf="envelope.responsibles?.length > 0">
    <div class="header align-items-center d-flex">
      <span class="font-weight-bold gray">{{ 'responsibles' | translate }}</span>
    </div>
    <div class="body">
      <dl class="mb-0">
        <dt *ngFor="let item of envelope.responsibles" [ngSwitch]="item.status">
          <div class="row">
            <div class="col-8">
              <fa-icon *ngSwitchCase="signatureStatus.Awaiting" class="mr-1 warning" placement="right"
                ngbTooltip="{{ getToolTipResponsibleMessage(item) | translate }}"
                [icon]="['fas','clock']"></fa-icon>
              <fa-icon *ngSwitchCase="signatureStatus.Filled" class="mr-1 success" placement="right"
                ngbTooltip="{{ getToolTipResponsibleMessage(item) | translate | titlecase }}"
                [icon]="['fas','check-circle']">
              </fa-icon>
              {{item.name}}
              <div class="labels-signature-date p-1" *ngSwitchCase="signatureStatus.Filled">
                {{ item.signatureDateTimeInfo | datetimeFormatLanguage:
                datetimeFormatLanguageEnum.datetimeFormatted }}
              </div>
            </div>
            <div class="col-4 text-right d-flex justify-content-end" *ngIf="envelope.status !== sentEnvelopeStatus.deleted">
              <button class="cdx-btn__icon--xs primary border-less"
                *ngIf="(item.canShowResend && item.phoneNumber != '' && this.canSendWhatsApp && item.sendWhatsApp)"
                (click)="resendWhatsApp(item)">
                <fa-icon class="default text-right" ngbTooltip="{{ 'notificationResendWhatsApp' | translate | titlecase }}"
                  [icon]="['fab','whatsapp']">
                </fa-icon>
              </button>
              <button class="cdx-btn__icon--xs primary border-less mr-2" *ngIf="item.canShowResend"
                (click)="resendMail(item)">
                <fa-icon class="default text-right" ngbTooltip="{{ 'resendMail' | translate | titlecase }}"
                  [icon]="['far','envelope']">
                </fa-icon>
              </button>
            </div>
          </div>
          <div *ngIf="item.motiveRefusal" class="ml-2 mb-2 mt-1"><i>{{ item.motiveRefusal }}</i></div>
        </dt>
      </dl>
    </div>
  </cdx-card-collapse>
</div>

<div class="mb-3">
  <cdx-card-collapse [isCollapsed]="false" [isCardBox]="true" *ngIf="envelope.authorizers.length > 0">
    <div class="header align-items-center d-flex text-nowrap">
      <span class="font-weight-bold gray">{{ 'authorizers' | translate }}</span>
      <span class="labels-gray-num">&nbsp;&nbsp;{{ totalApprovedAuthorizations }}/{{ envelope.authorizers.length}}</span>
      <span class="labels-gray">&nbsp;&nbsp;{{ "authorizations" | translate }}</span>
    </div>
    <div class="body">
      <dl class="mb-0">
        <dt *ngFor="let item of envelope.authorizers" [ngSwitch]="item.status">
          <div class="row">
            <div class="col-8">
              <fa-icon *ngSwitchCase="signatureStatus.Awaiting" class="mr-1 warning" placement="right"
                ngbTooltip="{{ getToolTipAuthorizeMessage(item) | translate }}" [icon]="['fas','clock']"></fa-icon>
              <fa-icon *ngSwitchCase="signatureStatus.Approval_approved" class="mr-1 success" placement="right"
                ngbTooltip="{{ getToolTipAuthorizeMessage(item) | translate | titlecase }}"
                [icon]="['fas','check-circle']">
              </fa-icon>
              <fa-icon *ngSwitchCase="signatureStatus.Approval_reproved" class="mr-1 danger" placement="right"
                ngbTooltip="{{ getToolTipAuthorizeMessage(item) | translate }}" [icon]="['fas','times-circle']">
              </fa-icon>
              {{item.name}}
              <div class="labels-signature-date p-1" *ngSwitchCase="signatureStatus.Approval_approved">
                {{ item.signatureDateTimeInfo | datetimeFormatLanguage:
                datetimeFormatLanguageEnum.datetimeFormatted }}
              </div>
            </div>
            <div class="col-4 text-right d-flex justify-content-end" *ngIf="envelope.status !== sentEnvelopeStatus.deleted">
              <button class="cdx-btn__icon--xs primary border-less"
                *ngIf="(item.canShowResend && item.phoneNumber != '' && this.canSendWhatsApp && item.sendWhatsApp)"
                (click)="resendWhatsApp(item, confirmModal)"
                (contextmenu)="showLinkToSign(item)">
                <fa-icon class="default text-right" ngbTooltip="{{ 'notificationResendWhatsApp' | translate | titlecase }}"
                  [icon]="['fab','whatsapp']">
                </fa-icon>
              </button>
              <button class="cdx-btn__icon--xs primary border-less mr-2" *ngIf="item.canShowResend"
                (click)="resendMail(item, confirmModal)"
                (contextmenu)="showLinkToSign(item)">
                <fa-icon class="default text-right" ngbTooltip="{{ 'resendMail' | translate | titlecase }}"
                  [icon]="['far','envelope']">
                </fa-icon>
              </button>
            </div>
          </div>
          <div *ngIf="item.motiveRefusal" class="ml-2 mb-2 mt-1"><i>{{ item.motiveRefusal }}</i></div>
        </dt>
      </dl>
    </div>
  </cdx-card-collapse>
</div>
<div class="mb-3">
  <cdx-card-collapse [isCollapsed]="false" [isCardBox]="true">
    <div class="header align-items-center d-flex">
      <span class="font-weight-bold gray">{{ "signatories" | translate | titlecase }}</span>
      <span class="labels-gray-num">&nbsp;&nbsp;{{ envelope.totalSignaturesCompleted }}/{{ envelope.signatories.length
        }}</span>
      <span class="labels-gray">&nbsp;&nbsp;{{ "signatures" | translate }}</span>
    </div>
    <div class="body">
      <dl class="mb-0">
        <dt *ngFor="let item of envelope.signatories" [ngSwitch]="item.status">
          <div style="min-height: 24px;" class="row">
            <div class="col-8">
              <fa-icon *ngSwitchCase="signatureStatus.Awaiting" class="mr-1 warning" placement="right"
                ngbTooltip="{{ getToolTipSignatoryMessage(item) | translate }}" [icon]="['fas','clock']"></fa-icon>
              <fa-icon *ngSwitchCase="signatureStatus.Signed" class="mr-1 success" placement="right"
                ngbTooltip="{{ getToolTipSignatoryMessage(item) | translate | titlecase }}"
                [icon]="['fas','check-circle']">
              </fa-icon>
              <fa-icon *ngSwitchCase="signatureStatus.Declined" class="mr-1 danger" placement="right"
                ngbTooltip="{{ getToolTipSignatoryMessage(item) | translate }}" [icon]="['fas','times-circle']">
              </fa-icon>
              <span *ngIf="envelope.isOrdered" style="font-size: 12px;">{{item.order}}º </span>{{item.name}}
              <div class="labels-signature-date p-1" *ngSwitchCase="signatureStatus.Signed">
                {{ item.signatureDateTimeInfo |
                datetimeFormatLanguage:datetimeFormatLanguageEnum.datetimeFormatted }} • {{
                getDescriptionSignatureType(item.signatureTypeSelected) | translate | titlecase }}
              </div>
            </div>
            <div class="col-4 text-right" *ngIf="envelope.status !== sentEnvelopeStatus.deleted">
              <button class="cdx-btn__icon--xs primary border-less" (click)="toAssigned(item.accessKey)"
                *ngIf="isObserver && item.showSignatureInPerson">
                <fa-icon class="default" ngbTooltip="{{ 'signNow' | translate | titlecase }}"
                  [icon]="['far','signature']">
                </fa-icon>
              </button>
              <div class="d-flex justify-content-end">
                <button class="cdx-btn__icon--xs primary border-less"
                  *ngIf="(item.canShowResend && item.phoneNumber != '' && item.signatureType !== signatureType.INPERSON && this.canSendWhatsApp && item.sendWhatsApp)" (click)="resendWhatsApp(item)"
                    (contextmenu)="showLinkToSign(item)">
                    <fa-icon class="default" ngbTooltip="{{ 'notificationResendWhatsApp' | translate | titlecase }}" [icon]="['fab', 'whatsapp']">
                    </fa-icon>
                </button>
                <button class="cdx-btn__icon--xs primary border-less"
                    *ngIf="item.canShowResend && item.signatureType !== signatureType.INPERSON" (click)="resendMail(item)"
                    (contextmenu)="showLinkToSign(item)">
                    <fa-icon class="default" ngbTooltip="{{ getNotificationMessage(item) }}" [icon]="['far','envelope']">
                    </fa-icon>
                </button>
              </div>
            </div>
          </div>
        </dt>
      </dl>
    </div>
  </cdx-card-collapse>
</div>
<div class="mb-3">
  <cdx-card-collapse [isCollapsed]="false" [isCardBox]="true"
    *ngIf="envelope.status === sentEnvelopeStatus.deleted && envelope.reasonDelete !== null">
    <div class="header align-items-center d-flex">
      <span class="font-weight-bold gray">{{ "reasonDeleted" | translate | titlecase }}</span>
    </div>
    <div class="body">
      <div class="d-flex w-100 flex-column">
        <textarea readonly>{{ envelope.reasonDelete }}</textarea>
      </div>
    </div>
  </cdx-card-collapse>
</div>
<div class="mb-3">
  <cdx-card-collapse [isCollapsed]="false" [isCardBox]="true">
    <div class="header align-items-center d-flex">
      <span class="font-weight-bold gray">{{ "documents" | translate | titlecase }}</span>
    </div>
    <div class="body">
      <dl class="mb-0">
        <dt *ngFor="let item of envelope.files">
          <div class="row">
            <div class="col">
              <span class="text-column">
                <fa-icon style="padding-right: 1rem;" class="fa-fw gray inline" [icon]="['far', 'file-alt']">
                </fa-icon>{{ item.name }}
              </span>
            </div>
          </div>
        </dt>
      </dl>
    </div>
  </cdx-card-collapse>
</div>
  <div class="d-flex w-100 flex-column">
    <div class="col m-0 p-0">
      <button class="cdx-button cdx-button--primary cdx-button--block btn-download mb-1" (click)="downloadOriginalFile()">
        <fa-icon class="fa-fw cdx-button__icon icon-download" [icon]="['fal','arrow-alt-to-bottom']"></fa-icon>
        <span class="cdx-button__text">
          {{ (envelope.responsibles?.length > 0 && envelope.responsibles[0].status === signatureStatus.Filled ? "filledOriginal" : "original") | translate }}
        </span>
      </button>
    </div>
    <div class="col m-0 p-0" *ngIf="envelope.status !== sentEnvelopeStatus.deleted">
      <button *ngIf="isCompleted()" class="cdx-button cdx-button--primary cdx-button--block btn-download mb-1"
        (click)="downloadSignedFile()">
        <fa-icon class="fa-fw cdx-button__icon icon-download" [icon]="['fal','arrow-alt-to-bottom']"></fa-icon>
        <span class="cdx-button__text">{{ "signed" | translate }}</span>
      </button>
    </div>
    <div class="col m-0 p-0" *ngIf="envelope.status !== sentEnvelopeStatus.deleted" ngbDropdown>

      <button class="cdx-button cdx-button--primary cdx-button--block btn-download mb-1" *ngIf="!disablePrinting()"
        ngbDropdownToggle aria-haspopup="true" aria-expanded="false">
        <fa-icon class="fa-fw cdx-button__icon icon-download" [icon]="['fal','arrow-alt-to-bottom']"></fa-icon>
        <span class="cdx-button__text">{{ "printing" | translate }}</span>
        <fa-icon class="fa-fw cdx-button__icon" [icon]="['fas','caret-down']"></fa-icon>
        <div ngbDropdownMenu>
          <button ngbDropdownItem (click)="downloadPrintingFile(true)">
            <span>{{ 'printingWithStamps' | translate | titlecase }}</span>
          </button>
          <button ngbDropdownItem (click)="downloadPrintingFile(false)">
            <span>{{ (elementSelected ? 'contacts.envelopeEdit.saveAndUpdateContact' :
              'printingNoStamps') | translate | titlecase }}</span>
          </button>
        </div>
      </button>
    </div>
  </div>



  <div class="d-flex w-100 flex-column" *ngIf="canViewActionsButton && envelope.status !== sentEnvelopeStatus.deleted">
    <div class="col m-0 p-0">
      <button *ngIf="!isDiscardDisabled()"
        class="cdx-button cdx-button--primary cdx-button--danger cdx-button--block btn-download mb-1"
        (click)="showModalEnvelopeEditOrDeleteOrArchived(modalEnvelopeDeleteForm, 'Signer_Enviado_Detalhe_Descartar')">
        <fa-icon class="fa-fw cdx-button__icon icon-download" [icon]="['fal','trash-alt']"></fa-icon>
        <span class="cdx-button__text">{{ "discard" | translate }}</span>
      </button>
    </div>
  </div>

  <div class="d-flex w-100 flex-column" *ngIf="envelope.status === sentEnvelopeStatus.deleted">
    <div class="col m-0 p-0">
      <button *ngIf="!isCompleted()"
        class="cdx-button cdx-button--primary cdx-button--danger cdx-button--block btn-download mb-1"
        (click)="showModalEnvelopeEditOrDeleteOrArchived(modalEnvelopeArchivedForm, 'Signer_Enviado_Detalhe_Arquivar')">
        <fa-icon class="fa-fw cdx-button__icon icon-download" [icon]="['fal','trash-alt']"></fa-icon>
        <span class="cdx-button__text">{{ "envelopeSideRigth.archived" | translate }}</span>
      </button>
    </div>
  </div>

</cdx-aside-right>

<ng-template #modalEnvelopeForm>
  <app-envelope-details-edit (modalCloseEmmiter)="confirmModalClose()" (updateEnvelope)="updateEnvelope($event)"
    [elementSelected]=elementSelected>
  </app-envelope-details-edit>
</ng-template>

<ng-template #modalEnvelopeDeleteForm>
  <app-envelope-details-delete (modalCloseEmmiter)="confirmModalClose()" (deleteEnvelope)="onDiscardEnvelopeDeleted()"
    [elementSelected]=elementSelected>
  </app-envelope-details-delete>
</ng-template>

<ng-template #modalEnvelopeArchivedForm>
  <app-envelope-details-archived (modalCloseEmmiter)="confirmModalClose()" (deleteEnvelope)="onEnvelopeArchived()"
    [elementSelected]=elementSelected>
  </app-envelope-details-archived>
</ng-template>
